/**
 * Which links the palette may offer on an ecomap.
 *
 * Two vocabularies at once, because Hartman's ecomap holds both. The ties are
 * a star around the centre: each one runs between the centre and one system,
 * never between two systems, which would be a different instrument. Inside the
 * circle sits the household, drawn as the small genogram it is — so couples,
 * children and emotional bonds are offered here too, by the same rules that
 * govern them on a genogram.
 */

import {
    genogramLinkOptions,
    type BoardContext,
    type LinkOption,
    type Selectable,
} from "./genogramRules";

const isCentre = (element: Selectable): boolean =>
    Boolean(element && "type" in element && element.type === "centre");

const isSystem = (element: Selectable): boolean =>
    Boolean(element && "type" in element && element.type === "system");

export const ecomapLinkOptions = (
    a: Selectable,
    b: Selectable,
    context: BoardContext = { links: [] },
): LinkOption[] => {
    const distinct = Boolean(a && b && a.id !== b.id);
    const centreToSystem =
        distinct && ((isCentre(a) && isSystem(b)) || (isSystem(a) && isCentre(b)));

    return [
        ...genogramLinkOptions(a, b, context),
        {
            type: "system",
            enabled: centreToSystem,
            reasonKey: centreToSystem ? undefined : "systemicMap.rules.systemNeedsCentre",
        },
    ];
};

export type { LinkOption } from "./genogramRules";
